import classNames from "classnames";
import * as React from "react";
import { icon } from "~/sharedComponents/icons";
import { imageAnnotationsResx } from "../../../resxDist/imageAnnotationsResx";
import { ButtonContrast, ButtonContrastIcon, ButtonFlag } from "../../../sharedComponents/buttons";
import { EmptyList, EmptyListThemes } from "../../../sharedComponents/emptyList/EmptyList";
import { VerticalScrollbars } from "../../../sharedComponents/scrollbars/VerticalScrollbars";
import { AnnotationContentContainer } from "../containers/AnnotationContentContainer";
import { AnnotationItemExtended } from "../types";
import { ImageAnnotationKeyTypes } from "./ImageAnnotations";
import * as styles from "./ImageAnnotationsComments.less";
import { AnnotationContentTheme } from "./ImageAnnotationsContent";

const commentsListScrollbarStyles: React.CSSProperties = { height: "100%", width: "100%" };

interface ImageAnnotationsCommentsProps {
    annotations?: AnnotationItemExtended[];
    isMessagesShown: boolean;
    hasAnnotations: boolean;
    hideMessagesContainer?: () => void;
    onChange: F1<AnnotationItemExtended, void>;
    onSubmit: F<void>;
}

type Props = ImageAnnotationsCommentsProps;

interface State {
    isScrolling: boolean;
}

export class ImageAnnotationsComments extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isScrolling: false,
        };

        this.onScrollStop = this.onScrollStop.bind(this);
        this.onScrollStart = this.onScrollStart.bind(this);
    }
    onScrollStop() {
        this.setState({ isScrolling: false });
    }

    onScrollStart() {
        this.setState({ isScrolling: true });
    }

    render() {
        const { annotations, hideMessagesContainer, isMessagesShown, onChange, onSubmit, hasAnnotations } = this.props;
        const containerClassName = classNames(
            "annotation_messages_panel",
            styles.messages,
            isMessagesShown ? styles.show : styles.hide
        );
        return (
            <div className={containerClassName}>
                <div className={styles.container}>
                    <div className={styles.messages_header}>
                        <ButtonContrast
                            iconName={icon.chevron_left}
                            action={hideMessagesContainer}
                            text={imageAnnotationsResx.comments}
                            flags={ButtonFlag.Small}
                        />
                        <ButtonContrastIcon iconName={icon.cross} action={hideMessagesContainer} />
                    </div>
                    <div className={styles.border} />
                    <div className={styles.scroll_container}>
                        <VerticalScrollbars
                            style={commentsListScrollbarStyles}
                            onScrollStart={this.onScrollStart}
                            onScrollStop={this.onScrollStop}
                            darkTheme={true}
                        >
                            {hasAnnotations ? (
                                annotations.map((annotation: AnnotationItemExtended) => (
                                    <AnnotationContentContainer
                                        annotation={annotation}
                                        theme={[AnnotationContentTheme.light, AnnotationContentTheme.inner_message]}
                                        key={ImageAnnotationKeyTypes.message + annotation.data.id}
                                        isInlineEdit={true}
                                        onChange={onChange}
                                        onSubmit={onSubmit}
                                        isParentScrolling={this.state.isScrolling}
                                        active={annotation.active}
                                    />
                                ))
                            ) : (
                                <EmptyList
                                    description={imageAnnotationsResx.no_comment}
                                    theme={EmptyListThemes.only_text}
                                />
                            )}
                        </VerticalScrollbars>
                    </div>
                </div>
            </div>
        );
    }
}
